import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SimpleModalComponent } from 'src/app/shared/modals/simple-modal/simple-modal.component';
import { Title, Meta } from '@angular/platform-browser';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Location } from '@angular/common';
import { LanguageUtil } from 'src/app/shared/util/language-util';
import { IdiomaService } from 'src/app/core/services/idioma.service';
import { LoadingModalComponent } from 'src/app/shared/modals/loading-modal/loading-modal.component';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  formGroup: FormGroup;
  data: any;

  idiomaSelecionado;
  idiomas;

  urlLogin = environment.url + 'Login.do';
  languageParam;

  constructor(
    private translate: TranslateService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private titleService: Title,
    private meta: Meta,
    private localize: LocalizeRouterService,
    private location: Location,
    private router: Router,
    private idiomaService: IdiomaService,
    private gaService: GoogleAnalyticsService
  ) {
    this.carregarFormGroup();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
      this.idiomaSelecionado = this.idiomaService.getIdioma();
    });
  }

  ngOnInit() {
    this.carregarDados();

    this.idiomaSelecionado = this.idiomaService.getIdioma();
    this.idiomas = this.idiomaService.getIdiomas();

    this.activatedRoute.queryParams.subscribe(params => {
      const language = this.localize.parser.currentLang;

      const erroLogin = params.erroLogin;
      const sessaoExpirada = params.sessaoExpirada;

      if (erroLogin === 'true') {
        const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });

        let mensagem;
        if (language === 'pt') {
          mensagem = 'Empresa, ID e/ou senha inválidos.';
        } else if (language === 'es') {
          mensagem = 'Empresa, ID y/o contraseña inválidos.';
        } else {
          mensagem = 'Company, ID and / or password are invalid.';
        }

        modalRef.componentInstance.message = mensagem;
        this.location.replaceState(this.localize.parser.urlPrefix + '/login');
      }

      if (sessaoExpirada === 'true') {
        const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });

        let mensagem;
        if (language === 'pt') {
          mensagem = 'Sessão expirada. Por favor, faça o login novamente.';
        } else if (language === 'es') {
          mensagem = 'Sesión expirada. Por favor, inicie nuevamente la sesión.';
        } else {
          mensagem = 'Session expired. Please, login again.';
        }

        modalRef.componentInstance.message = mensagem;
        this.location.replaceState(this.localize.parser.urlPrefix + '/login');
      }
    });
  }

  carregarFormGroup() {
    this.formGroup = this.formBuilder.group(
      {
        formNomeEmpresa: new FormControl('', Validators.required),
        formUsuario: new FormControl('', Validators.required),
        formSenha: new FormControl('', Validators.required)
      }
    );
  }

  carregarDados() {
    this.translate.get('LOGIN').subscribe(res => {
      this.data = res;
      this.titleService.setTitle(this.data.HEADER_TITLE);
      this.meta.updateTag({ name: 'description', content: this.data.META_DESCRIPTION });
      this.meta.updateTag({ name: 'keywords', content: this.data.META_KEYWORDS });
      this.gaService.pageView(this.router.url);
    });
    this.languageParam = LanguageUtil.retornaLanguage(this.translate.currentLang);
  }

  alterarIdioma(idioma) {
    this.translate.use(idioma);
  }

  onSubmit() {
    this.modalService.open(LoadingModalComponent, { windowClass: 'xlModal', centered: true, backdrop: 'static' });
  }
}
